const BASE = 'https://roasterycoffee.co.in/wp-content/uploads';

export const beans = [
  {
    id: 1,
    badge: 'new',
    badgeLabel: 'New Arrival',
    origin: 'Coorg, Karnataka',
    name: 'Mooleh Manay Estate — Excelsa',
    process: 'Natural Process · Light Roast',
    notes: ['Blueberry', 'Dark Chocolate', 'Caramel'],
    score: 88,
    priceRange: '₹950 – ₹3,700',
    price: 950,
    img: `${BASE}/2026/01/MOOLEH-MANAY-EXCLESA-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/mooleh-manay-estate-excelsa/',
    filter: ['single', 'light'],
  },
  {
    id: 2,
    badge: 'rare',
    badgeLabel: 'Single Estate',
    origin: 'Coorg, Karnataka',
    name: 'Mooleh Manay Estate — SLN 795',
    process: 'Washed Process · Medium Roast',
    notes: ['Brown Sugar', 'Stone Fruit', 'Walnut'],
    score: 85,
    priceRange: '₹750 – ₹2,900',
    price: 750,
    img: `${BASE}/2026/01/MOOLEH-MANAY-SLN-795-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/mooleh-manay-estate/',
    filter: ['single', 'medium'],
  },
  {
    id: 3,
    badge: 'bestseller',
    badgeLabel: 'Bestseller',
    origin: 'In-House Blend',
    name: 'Cappuccino Blend',
    process: 'Medium Roast · Espresso-Ready',
    notes: ['Chocolate', 'Nuts', 'Caramel'],
    score: 86,
    priceRange: '₹650 – ₹2,500',
    price: 650,
    img: `${BASE}/2024/07/1-1-1-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/espresso-milk-blend/',
    filter: ['blend', 'medium'],
    featured: true,
  },
  {
    id: 4,
    badge: 'rare',
    badgeLabel: 'Single Estate',
    origin: 'Chikmagalur, Karnataka',
    name: 'Mandalkhan Estate',
    process: 'Washed Process · Medium Roast',
    notes: ['Citrus', 'Floral', 'Bright Acidity'],
    score: 84,
    priceRange: '₹650 – ₹2,500',
    price: 650,
    img: `${BASE}/2024/07/1-750x943-1.png-1-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/mandalkhan-estate-2/',
    filter: ['single', 'medium'],
  },
  {
    id: 5,
    badge: 'new',
    badgeLabel: 'New Arrival',
    origin: 'Baarbara Estate',
    name: 'Baarbara Estate — Frozen Cherry',
    process: 'Experimental Process · Light Roast',
    notes: ['Cherry', 'Rose', 'Tropical Fruit'],
    score: 90,
    priceRange: '₹850 – ₹3,300',
    price: 850,
    img: `${BASE}/2025/12/1-12-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/baarbara-estate-frozen-cherry/',
    filter: ['single', 'light'],
  },
  {
    id: 6,
    badge: 'bestseller',
    badgeLabel: 'Bestseller',
    origin: 'Baarbara Estate',
    name: 'Baarbara Estate — HSD',
    process: 'Natural Process · Medium Roast',
    notes: ['Dark Chocolate', 'Plum', 'Molasses'],
    score: 87,
    priceRange: '₹720 – ₹2,780',
    price: 720,
    img: `${BASE}/2024/11/1-1-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/baarbara-estate/',
    filter: ['single', 'medium'],
  },
  {
    id: 7,
    badge: 'new',
    badgeLabel: 'New Arrival',
    origin: 'Baarbara Estate',
    name: 'Baarbara Estate — Pineapple',
    process: 'Anaerobic Process · Light Roast',
    notes: ['Pineapple', 'Guava', 'Candy'],
    score: 89,
    priceRange: '₹780 – ₹3,020',
    price: 780,
    img: `${BASE}/2025/12/baarbara-estate-pineapple-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/baarbara-estate-pineapple/',
    filter: ['single', 'light'],
  },
  {
    id: 8,
    badge: 'rare',
    badgeLabel: 'Limited',
    origin: 'Ratnagiri Estate',
    name: 'Ratnagiri Estate — Amara Rose',
    process: 'Natural Process · Light Roast',
    notes: ['Rose', 'Berry', 'Jasmine'],
    score: 91,
    priceRange: '₹850 – ₹3,300',
    price: 850,
    img: `${BASE}/2025/12/new-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/ratnagiri-estate-amara-rose/',
    filter: ['single', 'light'],
  },
  {
    id: 9,
    badge: 'rare',
    badgeLabel: 'Limited',
    origin: 'Ratnagiri Estate',
    name: 'Ratnagiri Estate — Seraphine',
    process: 'Washed Process · Light Roast',
    notes: ['Peach', 'Hibiscus', 'Honey'],
    score: 90,
    priceRange: '₹850 – ₹3,300',
    price: 850,
    img: `${BASE}/2025/12/new-seraphine-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/ratnagiri-estate-saraphina/',
    filter: ['single', 'light'],
  },
  {
    id: 10,
    badge: 'staff',
    badgeLabel: 'Staff Pick',
    origin: 'Wayanad, Kerala',
    name: 'Monsoon Malabar',
    process: 'Monsooned Process · Dark Roast',
    notes: ['Earthy', 'Low Acid', 'Full Body'],
    score: 83,
    priceRange: '₹650 – ₹2,500',
    price: 650,
    img: `${BASE}/2024/07/1-2-750x943.png`,
    productUrl: 'https://roasterycoffee.co.in/product/monsoon-malabar/',
    filter: ['single', 'dark'],
  },
  {
    id: 11,
    badge: 'bestseller',
    badgeLabel: 'Bestseller',
    origin: 'In-House Blend',
    name: 'Cold Brew Blend',
    process: 'Dark Roast · Concentrate-Ready',
    notes: ['Chocolate', 'Smoke', 'Rich Body'],
    score: 84,
    priceRange: '₹650 – ₹2,500',
    price: 650,
    img: `${BASE}/2024/07/1-1-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/cold-brew-blend/',
    filter: ['blend', 'dark'],
  },
  {
    id: 12,
    badge: 'new',
    badgeLabel: 'New',
    origin: 'Robusta · Karnataka',
    name: 'Harley Estate (Robusta)',
    process: 'Natural Process · Dark Roast',
    notes: ['Bold', 'Woody', 'Dark Cocoa'],
    score: 82,
    priceRange: '₹350 – ₹1,200',
    price: 350,
    img: `${BASE}/2025/08/1-5-750x938.png`,
    productUrl: 'https://roasterycoffee.co.in/product/harley-estate-robusta/',
    filter: ['single', 'dark'],
  },
];
